<!-- Header -->
<div class="row row--header">
  <span class="col-dot"></span>
  <span class="col-label">{{ headerLabel() }}</span>
  <span class="col-desc">{{ headerDescription() }}</span>
  <span class="col-value">{{ headerValue() }}</span>
</div>

<!-- Body rows -->
<mat-accordion multi displayMode="flat" class="explain-accordion" (mouseleave)="highlightedId.set(null)">
  @for (item of items(); track item.id) {
    <mat-expansion-panel class="explain-panel" [disabled]="!item.formulaLatex" [hideToggle]="!item.formulaLatex">
      <mat-expansion-panel-header
        [collapsedHeight]="'36px'"
        [expandedHeight]="'36px'"
        (mouseenter)="highlightedId.set(item.id)"
      >
        <mat-panel-title class="explain-header-content">
          <span class="col-dot"><span class="color-dot" [style.background-color]="item.color"></span></span>
          <span class="col-label cell-label">{{ item.label }}</span>
          <span class="col-desc cell-desc">{{ item.description }}</span>
          <span class="col-value cell-value" [style.color]="item.color">{{ item.value }}</span>
        </mat-panel-title>
      </mat-expansion-panel-header>

      @if (item.formulaLatex) {
        <ng-template matExpansionPanelContent>
          <div class="expansion-body">
            <dojo-markdown-viewer [content]="item.formulaLatex" />
          </div>
        </ng-template>
      }
    </mat-expansion-panel>
  }
</mat-accordion>
